var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#015D59",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h7v7H0zM0 11h7v7H0zM11 0h7v7h-7zM11 11h7v7h-7z"
}))));
export default SvgList;